import AttestationQuestion from '@/components/application_components/question_types/AttestationQuestion';
import CheckboxQuestion from '@/components/application_components/question_types/CheckboxQuestion';
import DateQuestion from '@/components/application_components/question_types/DateQuestion';
import HeaderText from '@/components/application_components/question_types/HeaderText';
import MultiCheckbox from '@/components/application_components/question_types/MultiCheckbox';
import PartnerShip from '@/components/application_components/question_types/PartnerShip';
import Signature from '@/components/application_components/question_types/Signature';
import SingleSelect from '@/components/application_components/question_types/SingleSelect';
import { QuestionProps } from '@/models/Question';
import ContactQuestion from './ContactQuestion';
import Hours from './Hours';
import EventQuestion from '../event_components/EventQuestion';
import TotalExpensePerCapita from './data/TotalExpensePerCapita';
import TotalExpensesValue from './data/TotalExpensesValue';
import DataUploadWrap from './data_upload/DataUploadWrap';
import IntegerQuestionType from './Integer';
import MoneyTypeQuestion from './Money';
import PercentTypeQuestion from './Percent';
import PopulationQuestionType from './Population';
import TextTypeQuestions from '@/components/application_components/question_types/TextTypeQuestions';
import { useContext } from 'react';
import { CurrentApplicationContext } from '@/Contexts/CurrentApplicationContext';
import { showChildQuestion } from '@/utils/questionUtil';
import SubheaderText from './SubheaderText';
import Year from './Year';

function QuestionSwitch({ question }: { question: QuestionProps }) {
  const { answers } = useContext(CurrentApplicationContext);

  if (
    question.parentQuestion != null &&
    question.parentQuestion.length > 0 &&
    !showChildQuestion(question, answers)
  ) {
    return null;
  }

  let questionComponent;
  switch (question.questionType) {
    case 'partner-ship':
      questionComponent = <PartnerShip question={question} />;
      break;
    case 'single select':
      questionComponent = <SingleSelect question={question} />;
      break;
    case 'year':
      questionComponent = <Year question={question} />;
      break;
    case 'date':
      questionComponent = <DateQuestion question={question} />;
      break;
    case 'header':
      questionComponent = <HeaderText question={question} />;
      break;
    case 'subheader':
      questionComponent = <SubheaderText question={question} />;
      break;
    case 'contact':
      questionComponent = <ContactQuestion question={question} />;
      break;
    case 'upload':
      questionComponent = <DataUploadWrap question={question} />;
      break;
    case 'checkbox':
      questionComponent = <CheckboxQuestion question={question} />;
      break;
    case 'multicheck':
      questionComponent = <MultiCheckbox question={question} />;
      break;
    case 'multiselect-3':
      questionComponent = <MultiCheckbox question={question} />;
      break;
    case 'multiselect':
      questionComponent = <MultiCheckbox question={question} />;
      break;
    case 'population':
      questionComponent = <PopulationQuestionType question={question} />;
      break;
    case 'money':
      questionComponent = <MoneyTypeQuestion question={question} />;
      break;
    case 'hours':
      questionComponent = <Hours question={question} />;
      break;
    case 'integer':
      questionComponent = <IntegerQuestionType question={question} />;
      break;
    case 'text':
      questionComponent = <TextTypeQuestions question={question} />;
      break;
    case 'percent':
      questionComponent = <PercentTypeQuestion question={question} />;
      break;
    case 'per capita':
      questionComponent = <TotalExpensePerCapita question={question} />;
      break;
    case 'total':
      questionComponent = <TotalExpensesValue question={question} />;
      break;
    case 'textbox':
      questionComponent = <TextTypeQuestions question={question} />;
      break;
    case 'attestation':
      questionComponent = <AttestationQuestion question={question} />;
      break;
    case 'e-sign':
      questionComponent = <Signature question={question} />;
      break;
    case 'event':
      questionComponent = <EventQuestion question={question} />;
      break;
    case 'partner-intake':
      questionComponent = null;
      break;
    default:
      questionComponent = <p>{question.questionText}</p>;
  }

  return <>{questionComponent}</>;
}

export default QuestionSwitch;
